import { capitalize } from '../../../utils/common';

const ML_EXPOSURE_TYPE = 'ML';

export const capitalizeExposureType = (type: string) => {
  if (type.toUpperCase() === ML_EXPOSURE_TYPE) {
    return ML_EXPOSURE_TYPE;
  }
  return capitalize(type);
};
